import { TemplateDevice } from "../../pages/devices/components/CreateDevicesFromTemplateDialog";

interface ValidationParams {
  parsedTemplateData: TemplateDevice[] | null;
  selectedNodes: { nodeId: string; nodeIP: string; nodeName: string }[];
  devicePassword: string;
}

interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

export const validateCreateDevicesFromTemplate = ({
  parsedTemplateData,
  selectedNodes,
  devicePassword,
}: ValidationParams): ValidationResult => {
  if (!parsedTemplateData) {
    return { isValid: false, errorMessage: "No template selected" };
  }

  const hasUnselectedNode = selectedNodes.some(
    node => !node.nodeId || !node.nodeIP || !node.nodeName
  );

  if (hasUnselectedNode) {
    return { isValid: false, errorMessage: "Please assign nodes" };
  }

  if (!devicePassword) {
    return { isValid: false, errorMessage: "Device password is required" };
  }

  return { isValid: true };
};
